import React from 'react';
import { escapeHtml } from '../utils';

interface JsonDiffViewProps {
  data: any;
  diffPaths: Set<string>;
  prefix?: string;
}

export function JsonDiffView({ data, diffPaths, prefix = '' }: JsonDiffViewProps) {
  if (data === null || data === undefined) return <span className="jt-null">null</span>;
  if (typeof data === 'string') {
    const isDiff = diffPaths.has(prefix);
    return <span className={`jt-string${isDiff ? ' jt-diff' : ''}`}>"{escapeHtml(data)}"</span>;
  }
  if (typeof data === 'number') {
    const isDiff = diffPaths.has(prefix);
    return <span className={`jt-number${isDiff ? ' jt-diff' : ''}`}>{data}</span>;
  }
  if (typeof data === 'boolean') {
    const isDiff = diffPaths.has(prefix);
    return <span className={`jt-boolean${isDiff ? ' jt-diff' : ''}`}>{String(data)}</span>;
  }

  if (Array.isArray(data)) {
    if (data.length === 0) return <span>{'[]'}</span>;
    return (
      <span>
        {'[\n'}
        {data.map((item, i) => (
          <span key={i}>
            {'  '.repeat((prefix.split('.').length || 0) + 1)}
            <JsonDiffView data={item} diffPaths={diffPaths} prefix={prefix} />
            {i < data.length - 1 ? ',\n' : '\n'}
          </span>
        ))}
        {'  '.repeat(prefix.split('.').length || 0)}{']'}
      </span>
    );
  }

  if (typeof data === 'object') {
    const entries = Object.entries(data);
    if (entries.length === 0) return <span>{'{}'}</span>;
    const indent = prefix ? '  '.repeat(prefix.split('.').length + 1) : '  ';
    const closingIndent = prefix ? '  '.repeat(prefix.split('.').length) : '';

    return (
      <span>
        {'{\n'}
        {entries.map(([key, val], i) => {
          const childPath = prefix ? `${prefix}.${key}` : key;
          const isKeyDiff = diffPaths.has(childPath);
          return (
            <span key={key}>
              {indent}
              <span className={`jt-key${isKeyDiff ? ' jt-diff' : ''}`}>"{key}"</span>
              {': '}
              <JsonDiffView data={val} diffPaths={diffPaths} prefix={childPath} />
              {i < entries.length - 1 ? ',\n' : '\n'}
            </span>
          );
        })}
        {closingIndent}{'}'}
      </span>
    );
  }

  return <span>{String(data)}</span>;
}
